export function SectionTitle() {
  return (
    <div className="rh-section-title">
      <h1 data-testid="page-title">
        Le mur de vos <em>radios</em>
      </h1>
      <p>
        Cliquez une pochette pour écouter. Le bouton <strong>Zap</strong>{" "}
        change de station instantanément.
      </p>
    </div>
  );
}
